// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_hz-a";
export var fulfillmentFormRail = "_hz-9";
export var headerTitleRow = "_hz-c";
export var orderDetailsWrapper = "_hz-7";
export var orderLinkTrigger = "_hz-2";
export var paymentInformationGrid = "_hz-h";
export var paymentSummaryColumn = "_hz-i";
export var shipmentContainer = "_hz-b";
export var shipmentDetailsMainPane = "_hz-8";
export var shipmentNavigationCard = "_hz-5";
export var shipmentNavigationRail = "_hz-3";
export var shipmentNavigationRailHeader = "_hz-4";
export var shipmentSummaryFact = "_hz-e";
export var shipmentSummaryGrid = "_hz-d";
export var shipmentSummaryMetadataRow = "_hz-f";
export var shipmentSummaryTags = "_hz-g";
export var shipmentWorkspace = "_hz-0";
export var shipmentWorkspaceContent = "_hz-6";
export var shipmentWorkspaceHeader = "_hz-1";